import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';

import { TimelineCategory } from './types';

export const DENTAL_PHOTO_WIDGET_ID = 'patient-profile-dental-photo-widget';

export const TIMELINE_CATEGORIES: TimelineCategory[] = [
  'all',
  'cbct',
  '2d',
  '3d',
  'transcripts',
  'photos',
];

export const TIMELINE_CATEGORY_BY_REPORT_TYPE: Record<
  ReportType,
  TimelineCategory
> = {
  [ReportType.ReportType_InvalidValue]: 'cbct',
  [ReportType.ReportType_CBCT_GP]: 'cbct',
  [ReportType.ReportType_CBCT_Endo]: 'cbct',
  [ReportType.ReportType_CBCT_Molar]: 'cbct',
  [ReportType.ReportType_Pano_GP]: '2d',
  [ReportType.ReportType_Pano_Bitewings]: '2d',
  [ReportType.ReportType_IOXRay_GP]: '2d',
  [ReportType.ReportType_CBCT_Segmentation]: '3d',
  [ReportType.ReportType_CBCT_IOS_Superimposition]: '3d',
  [ReportType.ReportType_CBCT_Implant]: '3d',
  [ReportType.ReportType_StudioImplant]: '3d',
  [ReportType.ReportType_CBCT_OrthoSlides]: '3d',
  [ReportType.ReportType_StudioOrtho]: '3d',
  [ReportType.ReportType_IOS_Segmentation]: '3d',
  [ReportType.ReportType_DentalPhoto_GP]: 'photos',
};

// Hero slides show panoramic previews (CBCT or pano reports); intraoral X-ray
// previews are the fallback when the patient has no panoramas yet. 3D
// previews are rendered thumbnails that need the full card context.
export const PANORAMA_SLIDE_REPORT_TYPES: ReportType[] = [
  ReportType.ReportType_CBCT_GP,
  ReportType.ReportType_Pano_GP,
  ReportType.ReportType_Pano_Bitewings,
];

export const FALLBACK_SLIDE_REPORT_TYPES: ReportType[] = [
  ReportType.ReportType_IOXRay_GP,
];
